// ========================================================
// FAST HIT Website — App Download Section
// Verified app links, QR code, and real mobile UI mockups
// ========================================================

import { Link } from 'react-router-dom';
import { Smartphone, QrCode, CheckCircle2, Download, ArrowRight } from 'lucide-react';
import './AppDownloadSection.css';

export function AppDownloadSection() {
  return (
    <section className="app-download" aria-labelledby="download-title">
      <div className="app-download__container">
        <div className="app-download__card">
          {/* Left Column: Details & Download Links */}
          <div className="app-download__content">
            <div className="section-eyebrow">
              <Smartphone size={14} className="text-cyan" />
              <span>Mobile Experience</span>
            </div>

            <h2 id="download-title" className="section-title">
              Take FAST HIT with You to Every Pitch
            </h2>

            <p className="section-subtitle">
              Live score directly from the boundary, follow matches on the go, and manage your team from anywhere.
            </p>

            {/* Value checklist */}
            <ul className="app-download__checklist">
              <li>
                <CheckCircle2 size={16} className="text-cyan" />
                <span>Instant notifications for wickets, half-centuries & results</span>
              </li>
              <li>
                <CheckCircle2 size={16} className="text-cyan" />
                <span>Fast, thumb-friendly scoring with undo and correction audit</span>
              </li>
              <li>
                <CheckCircle2 size={16} className="text-cyan" />
                <span>Works on phones and tablets with low data mode</span>
              </li>
            </ul>

            {/* CTAs and QR code */}
            <div className="app-download__actions-row">
              <div className="app-download__buttons">
                <Link to="/download" className="btn btn--primary btn--md btn--pill">
                  <Download size={16} />
                  <span>Download for Android</span>
                </Link>
                <Link to="/download" className="btn btn--outline btn--md btn--pill">
                  <Smartphone size={16} />
                  <span>iOS & Web App</span>
                </Link>
              </div>

              {/* QR Code preview */}
              <div className="app-download__qr-box">
                <div className="app-download__qr-visual">
                  <QrCode size={56} className="text-cyan" />
                </div>
                <span className="app-download__qr-label">Scan to open on phone</span>
              </div>
            </div>

            <p className="app-download__disclaimer text-muted text-xs">
              * Official releases available for Android and iOS. Also accessible directly in any modern mobile browser.
            </p>
          </div>

          {/* Right Column: Real Device Frame Mockup */}
          <div className="app-download__visual" aria-hidden="true">
            <div className="device-frame">
              <div className="device-frame__notch" />
              <div className="device-frame__screen">
                <img
                  src="/screens/screen1.png"
                  alt="FAST HIT Mobile App Screenshot"
                  className="device-frame__img"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
